import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth/auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Logging } from '../logging';
import { ApiService } from '../shared/api-service/api.service';

declare var jquery:any;
declare var $ :any;
declare var App:any;

@Component({
  selector: 'app-login-locked',
  templateUrl: './login-locked.component.html',
  styleUrls: ['./login-locked.component.css']
})
export class LoginLockedComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router) {


}

loading: Boolean = false;
hasError: Boolean = false;
errorMessage: string ;
userDetails: any ;
showForceLogoutError:any = false;
loginDetails:any;

  ngOnInit() {

    this.hasError = true;
    this.errorMessage = "Sorry, your account is locked. Please contact REDDE support!!.";

    if(!this.auth.loginDetailsSet()){
      this.router.navigate(['/login']);
    }
    // this.helpers.flashSuccess('Contact Created Successfully');
    this.loginDetails = this.auth.getLoginDetails();
    
  }

}



// WEBPACK FOOTER //
// ./src/app/login-locked/login-locked.component.ts